import { Action, AnyAction } from 'redux';
import { BIND_ACCOUNT_OWNER } from 'src/store/actions';

export interface AccountOwnerState {
    /** OIDC subject of the signed-in account the store belongs to; undefined = a guest. */
    subject?: string;
}

function accountOwnerReducer(state: AccountOwnerState = {}, action: AnyAction): AccountOwnerState {
    if (action.type !== BIND_ACCOUNT_OWNER) return state;
    const subject: string | undefined = action.subject ?? undefined;
    return state.subject === subject ? state : { subject };
}

/**
 * R56-9: a signed-in account's data never outlives him — another account signing in, or signing
 * out, resets the whole store. A guest's state (the cart) goes along into the login.
 */
export function leavesAccount(owner: AccountOwnerState | undefined, action: Action): boolean {
    if (action.type !== BIND_ACCOUNT_OWNER || owner?.subject === undefined) return false;
    return owner.subject !== ((action as AnyAction).subject ?? undefined);
}

export default accountOwnerReducer;
